import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={{name: '', name_vi: '', order: 0}} images={{thumbnail: ''}}/>

const BookCategoryFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const BookCategoryList = props => (
    <List {...props} filters={<BookCategoryFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <EditButton basePath="/book-category"/>
        </Datagrid>
    </List>
);

export const BookCategoryEdit = props => (
    <Edit {...props}>
        {form}
    </Edit>
);

export const BookCategoryCreate = props => (
    <Create title="Create a category" {...props}>
        {form}
    </Create>
);
